export default __webpack_public_path__ + "static/media/quick-safe-ride.f902d870.jpeg";